
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import zhTranslation from './local/zh/common';
import enTranslation from './local/en/common';

const resources = {
  zh: {
    translation: zhTranslation,
  },
  en: {
    translation: enTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'zh',
    initImmediate: false,
    fallbackLng: 'zh',
    debug: false,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
